import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import noDataImg from '~/assets/no-data.svg';
import { gray } from '~/components/mixins/color';

const Container = styled.div`
  display: ${(props) => (props.visible ? 'flex' : 'none')};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: calc(100% - 60px);

  .circle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${(props) => props.size};
    height: ${(props) => props.size};
    opacity: 0.9;
    user-select: none;
    pointer-events: none;
  }

  img {
    width: 70%;
    border: none;
    margin: 40px;
    opacity: 1;
  }

  h3 {
    color: ${gray.fade(0.6).string()};
    font-size: 22px;
  }
`;

function EmptyState(props) {
  const { size = '100px' } = props;

  if (!props.visible) {
    return null;
  }
  return (
    <Container visible={props.visible} size={size}>
      <div className='circle'>
        <img src={noDataImg} alt='logo' title={size} />
      </div>
      <h3>{props.text}</h3>
    </Container>
  );
}

EmptyState.propTypes = {
  text: PropTypes.string.isRequired,
  visible: PropTypes.bool,
};

EmptyState.defaultProps = {
  text: '',
  visible: false,
};

export default EmptyState;
